import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface ChipProps {
  label: ReactNode;
  /** Verilirse kapatma düğmesi çizilir (mockup: aktif filtre çipleri). */
  onRemove?: () => void;
  selected?: boolean;
  className?: string;
}

/** Etiket çipi — mockup filtre şeridi ("Durum: Yürürlükte, İncelemede, Onay Bekliyor ×"). */
export function Chip({ label, onRemove, selected = false, className }: ChipProps) {
  return (
    <span
      className={cn(
        "inline-flex h-7 items-center gap-1.5 rounded-full px-3 text-[13px] font-medium",
        selected ? "bg-primary-soft text-primary" : "bg-muted text-fg-strong",
        className,
      )}
    >
      {label}
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          aria-label={typeof label === "string" ? `${label} filtresini kaldır` : "Filtreyi kaldır"}
          className="flex size-3.5 items-center justify-center rounded-full text-current/70 hover:text-current"
        >
          <svg viewBox="0 0 20 20" fill="currentColor" className="size-3.5" aria-hidden="true">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      ) : null}
    </span>
  );
}
